import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { LenderService } from '../../../../../../services/lender.service';
import { StateService } from '../../../../../../services/state.service';
import { BrandService } from '../../../../../../services/brand.service';

@Component({
  selector: 'app-lender-listings',
  templateUrl: './lender-listings.component.html',
  styleUrls: ['./lender-listings.component.scss']
})
export class LenderListingsComponent implements OnInit, OnChanges {
  @Input() initialState: string = '';
  @Input() officeStatus: any;
  @Input() rowNumber: number;
  listings: Array<any> = [];
  isTopTenBestLenders: boolean = false;

  constructor(
    private stateService: StateService,
    private lenderService: LenderService,
    public brandService: BrandService,
  ) {

    this.lenderService.getListings().subscribe(x => {
      this.listings = x;
    })
  }

  ngOnInit() {  
    if(this.brandService.isTop10) {
      // this.isTopTenBestLenders = true;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.initialState?.currentValue != '') {
      this.selectState(this.initialState);
    }
  }

  selectState(state: string) {
    if (state) {
      this.stateService.setStateAbbreviation(state);
      this.lenderService.setState(state);
    }
  }

}
